import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { useComponentTheme } from '@chegg-ui/theme';
import { CaretIcon } from '@chegg-ui/horizon-icons';
import { getThemeConfig } from '@chegg-ui/input';
import { FloatingInputWrapper } from '@chegg-ui/input-wrapper';
import { FloatingNativeSelect } from '../styles';
export var NativeFloatingDropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      options = props.options,
      inputId = props.inputId,
      onSelectValue = props.onSelectValue,
      labelText = props.labelText,
      errorText = props.errorText,
      helperText = props.helperText,
      width = props.width,
      placeholder = props.placeholder,
      value = props.value,
      className = props.className,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      dataTest = props['data-test'],
      theme = props.theme,
      remainingSelectProps = _objectWithoutProperties(props, ["disabled", "options", "inputId", "onSelectValue", "labelText", "errorText", "helperText", "width", "placeholder", "value", "className", "onFocus", "onBlur", "adjustToBackgroundColor", "data-test", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Input',
    theme: getThemeConfig(theme)
  });
  var a11yErrorLabel = errorText ? "".concat(inputId, "_error") : '';
  return /*#__PURE__*/React.createElement(FloatingInputWrapper, {
    inputId: inputId,
    labelText: labelText,
    errorText: errorText,
    helperText: helperText,
    width: width,
    className: className,
    disabled: disabled,
    adjustToBackgroundColor: adjustToBackgroundColor,
    trailingIcon: componentTheme.showCaretDownIcon ? /*#__PURE__*/React.createElement(CaretIcon, {
      pointing: "down"
    }) : /*#__PURE__*/React.createElement(ChevronIcon, null) // the label is always floating as native select elements always present a value
    ,
    isFloating: true,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(FloatingNativeSelect, _extends({
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: function onChange(e) {
      return onSelectValue(e.target.value);
    },
    placeholder: placeholder,
    value: value,
    hasTrailingIcon: true,
    id: inputId,
    ref: ref,
    adjustToBackgroundColor: adjustToBackgroundColor,
    "data-test": dataTest || inputId,
    customTheme: componentTheme,
    "aria-labelledby": "".concat(inputId, "_label ").concat(a11yErrorLabel)
  }, remainingSelectProps), function () {
    return options.map(function (optionValue) {
      return /*#__PURE__*/React.createElement("option", {
        key: optionValue,
        value: optionValue
      }, optionValue);
    });
  }()));
});
NativeFloatingDropdown.displayName = 'NativeFloatingDropdown';
export default NativeFloatingDropdown;